import {
  Box,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Warning2 } from 'iconsax-react';
import BaseInput from './BaseInput';
import PasswordInput from './PasswordInput';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

const ErrorTypography = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.spacing(3)} !important`,
  fontWeight: 400,
  color: theme.palette.error.main,
  marginTop: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const InputBox = ({
  labelText = '',
  type = 'text',
  placeholder = '',
  onChange = '',
  ErrorInput = false,
  password = false,
  sx = {},
  checkStrong = false,
  value = '',
  errorMassage = '',
  name = '',
  onBlur = '',
  disabled = false,
}) => {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <Box sx={{ mb: smUp ? 4 : 4, ...sx }}>
      {password ? (
        <>
          <PasswordInput
            name={name}
            value={value}
            type={type}
            placeholder={placeholder}
            onChange={onChange}
            ErrorInput={ErrorInput}
            checkStrong={checkStrong}
            onBlur={onBlur}
          />
          {errorMassage ? (
            <ErrorTypography>
              <ErrorOutlineOutlinedIcon
                sx={{ width: 16, height: 16, color: theme.palette.error.main }}
              />
              {errorMassage}
            </ErrorTypography>
          ) : null}

          {/* {checkStrong ? <PasswordChecker value={value} /> : null} */}
        </>
      ) : (
        <>
          <BaseInput
            name={name}
            value={value}
            type={type}
            placeholder={placeholder}
            onChange={onChange}
            ErrorInput={ErrorInput}
            onBlur={onBlur}
            disabled={disabled}
          />
          {errorMassage ? (
            <ErrorTypography>
              <ErrorOutlineOutlinedIcon
                sx={{ width: 16, height: 16, color: theme.palette.error.main }}
              />

              {errorMassage}
            </ErrorTypography>
          ) : null}
        </>
      )}
    </Box>
  );
};
export default InputBox;
